/**
 * @file The NotificationsViewComponent is used to show the inbox and outbox and its details.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../core/dialog.service';
import { NotificationsService } from '../notifications.service';
import { AlertsService } from '../../core/alerts.service';
import { TranslateService } from '@ngx-translate/core';
import { DataViewBase } from './../../base/data-view/data-view.base';
/**
 * The NotificationsViewComponent is used to show the inbox and outbox and its details.
 *
 * @export
 * @class NotificationsViewComponent
 * @extends {DataViewComponent}
 */
var NotificationsViewComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsViewComponent, _super);
    /**
     * Creates an instance of NotificationsViewComponent.
     * @param {configurationsService} configurationsService The configuration service.
     * @param {Router} router The router
     * @param {ActivatedRoute} route The activated route.
     * @param {NotificationsService} notificationService The notifications service.
     * @param {DialogService} dialogService The dialog service.
     */
    function NotificationsViewComponent(router, route, notificationService, dialogService, alertsService, translateService) {
        return _super.call(this, router, route, notificationService, dialogService, alertsService, translateService) || this;
    }
    /**
     * Checks whether the given route is the detail route for the given item.
     *
     * @protected
     * @param {RouteConfiguration} detailRoute The route to check.
     * @param {Entity} item Checks the route for this item.
     * @returns {boolean} True when detailRoute matches with the given entity otherwise false.
     */
    NotificationsViewComponent.prototype.isDetailRouteForItem = function (detailRoute, item) {
        // Override and use the item parameter in derived classes.
        if (!_super.prototype.isDetailRouteForItem.call(this, detailRoute, item)) {
            return false;
        }
        var request = item;
        return detailRoute.path.toUpperCase().indexOf(request.Type) === 0;
    };
    return NotificationsViewComponent;
}(DataViewBase));
export { NotificationsViewComponent };
